<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.administracao.permissaoAcesso"
        ref="RkmDataTable"
    >
        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                v-if="authorize('administracao-permissao-acesso-update')"
                :to="{name: 'administracao-permissao-acesso-edit', params: {id: item.usuario_id}}"
                color="primary"
                small
                title="Editar"
                v-rkm-tooltip.hover
            >
                <rkm-icon icon="key" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import {authorization} from '@/mixins'

export default {
    computed: {
        fields() {
            return [
                {
                    key: 'usuario_nome',
                    label: 'Nome do usuário',
                    name: 'cadastro_usuario.nome',
                    searchable: true,
                    sortable: true,
                },
                {
                    class: 'col-min text-center',
                    key: 'actions',
                    label: 'Ações',
                },
            ]
        },
    },
    inject: ['repositories'],
    mixins: [authorization],
}
</script>